<template>
    <div class="company_store new-comp-store">
        <section class="breadcrumb-section pb-0">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <!-- <li class="breadcrumb-item"><a href="#">Cart</a></li> -->
                        <li class="breadcrumb-item active" aria-current="page">
                            Company Store
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="store_banner mt_20">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <h1
                            class="banner_heading2 text-white company_store_heading_box"
                        >
                            Company Store
                        </h1>
                        <a
                            href="/create-company-store"
                            class="btn btn_orange bg_primary_orange text_white py_18 px_42 mt_38"
                            >Create Company Store</a
                        >
                    </div>
                </div>
            </div>
        </section>

        <!-- shop_by_brand section -->

        <section class="cmn-section shop_by_brand pt_52 pb_60">
            <div class="container">
                <div class="row">
                    <div
                        class="col-md-12 col-lg-10 col-xlg-7 m-auto text-center"
                    >
                        <div class="section_heading_box">
                            <h1 class="heading1 mb-0">
                                Your E-commerce Platform
                            </h1>
                            <p
                                class="font_size_18 easily_p mt_12 com-store_para"
                            >
                                Easily connect employees to your branded
                                products via your own company store. Through one
                                intuitive portal, everyone in your company can
                                shop, customize, and order branded items
                                according to the parameters you set.
                            </p>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div
                            class="owl-carousel shop_by_brand_logo col-md-12 d-flex pl_54 pr_54"
                        >
                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <a href="/created-company-store">
                                        <img
                                            src="/maincss/images/brand_logo_1.png"
                                            alt="brand_logo"
                                            class="w-100 m-auto"
                                        />
                                    </a>
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <a href="/created-company-store">
                                        <img
                                            src="/maincss/images/brand_logo_2.png"
                                            alt="brand_logo"
                                            class="w-100 m-auto"
                                        />
                                    </a>
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <a href="/created-company-store">
                                        <img
                                            src="/maincss/images/brand_logo_3.png"
                                            alt="brand_logo"
                                            class="w-100 m-auto"
                                        />
                                    </a>
                                </div>
                            </div>

                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <a href="/created-company-store">
                                        <img
                                            src="/maincss/images/brand_logo_4.png"
                                            alt="brand_logo"
                                            class="w-100 m-auto"
                                        />
                                    </a>
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <a href="/created-company-store">
                                        <img
                                            src="/maincss/images/brand_logo_5.png"
                                            alt="brand_logo"
                                            class="w-100 m-auto"
                                        />
                                    </a>
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_6.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                            </div>

                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_7.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_8.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_9.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                            </div>

                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_10.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_11.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_12.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                            </div>

                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_13.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_14.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_15.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                            </div>

                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_16.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_17.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_18.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                            </div>
                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_1.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_2.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_3.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                            </div>

                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_4.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_5.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_6.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                            </div>

                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_7.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_8.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_9.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                            </div>

                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_10.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_11.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_12.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                            </div>

                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_13.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_14.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_15.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                            </div>

                            <div class="item">
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_16.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_17.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                                <div class="brand_logo d-block text-center">
                                    <img
                                        src="/maincss/images/brand_logo_18.png"
                                        alt="brand_logo"
                                        class="w-100 m-auto"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="benfits_compnay_store">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="heading1 text-center mb_44">
                            Benefits Of Company Store
                        </h1>

                        <div
                            class="dashboard_design company_store_tab_content d-md-flex mb_60"
                        >
                            <div class="side_bar company_store_sidebar px-0">
                                <ul
                                    id="tabs"
                                    role="tablist"
                                    class="nav nav-tabs side_bar_links mt_2 p-0"
                                >
                                    <li class="nav-item">
                                        <a
                                            href="#pane-A"
                                            id="tab-A"
                                            class="nav-link active"
                                            data-toggle="tab"
                                            role="tab"
                                        >
                                            <img
                                                src="/maincss/images/seamless.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Seamless</a
                                        >
                                    </li>

                                    <li class="nav-item">
                                        <a
                                            href="#pane-B"
                                            id="tab-B"
                                            class="nav-link"
                                            data-toggle="tab"
                                            role="tab"
                                        >
                                            <img
                                                src="/maincss/images/dashboard_link_1.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Intuitive</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="#pane-C"
                                            id="tab-C"
                                            class="nav-link"
                                            data-toggle="tab"
                                            role="tab"
                                        >
                                            <img
                                                src="/maincss/images/dashboard_link_2.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manageable</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="#pane-D"
                                            id="tab-D"
                                            class="nav-link"
                                            data-toggle="tab"
                                            role="tab"
                                        >
                                            <img
                                                src="/maincss/images/dashboard_link_3.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Customizable</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="#pane-E"
                                            id="tab-E"
                                            class="nav-link"
                                            data-toggle="tab"
                                            role="tab"
                                        >
                                            <img
                                                src="/maincss/images/dashboard_link_4.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Accessible</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="#pane-F"
                                            id="tab-F"
                                            class="nav-link"
                                            data-toggle="tab"
                                            role="tab"
                                        >
                                            <img
                                                src="/maincss/images/dashboard_link_5.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Real-Time</a
                                        >
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="#pane-G"
                                            id="tab-G"
                                            class="nav-link"
                                            data-toggle="tab"
                                            role="tab"
                                        >
                                            <img
                                                src="/maincss/images/dashboard_link_6.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Insightful</a
                                        >
                                    </li>
                                </ul>
                            </div>

                            <div class="left_panel">
                                <div
                                    id="content"
                                    class="tab-content"
                                    role="tablist"
                                >
                                    <!-- tab start -->
                                    <div
                                        id="pane-A"
                                        class="card tab-pane fade show active"
                                        role="tabpanel"
                                        aria-labelledby="tab-A"
                                    >
                                        <div
                                            id="collapse-A"
                                            class="collapse show"
                                            data-parent="#content"
                                            role="tabpanel"
                                        >
                                            <div class="card-body">
                                                <h4
                                                    class="font_size_20 a_seamless_head"
                                                >
                                                    A Seamless Experience
                                                </h4>
                                                <p
                                                    class="font_size_18 mt_12 a_seamless_p mb_4"
                                                >
                                                    Lorem Ipsum is simply dummy
                                                    text of the printing and
                                                    typesetting industry. Lorem
                                                    Ipsum has been the
                                                    industry’s standard dummy
                                                    text ever since the 1500s,
                                                    when an unknown printer took
                                                    a galley of type and
                                                    scrambled it to make a type
                                                    specimen book. It has
                                                    survived not only five
                                                    centuries. Lorem Ipsum is
                                                    simply dummy text of the
                                                    printing and typesetting
                                                    industry. Lorem Ipsum has
                                                    been the industry’s standard
                                                    dummy text ever since the
                                                    1500s, when an unknown
                                                    printer took a galley of
                                                    type and scrambled it to
                                                    make a type specimen book.
                                                    It has survived not only
                                                    five centurie.
                                                </p>
                                                <img
                                                    src="/maincss/images/tablet_imac.png"
                                                    alt=" "
                                                    class="w-auto mt_34"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- tab end -->

                                    <!-- tab start -->
                                    <div
                                        id="pane-B"
                                        class="card tab-pane fade"
                                        role="tabpanel"
                                        aria-labelledby="tab-B"
                                    >
                                        <div
                                            id="collapse-B"
                                            class="collapse"
                                            data-parent="#content"
                                            role="tabpanel"
                                        >
                                            <div class="card-body">
                                                <h4
                                                    class="font_size_20 a_seamless_head"
                                                >
                                                    Intuitive
                                                </h4>
                                                <p
                                                    class="font_size_18 mt_12 a_seamless_p mb_4"
                                                >
                                                    Lorem Ipsum is simply dummy
                                                    text of the printing and
                                                    typesetting industry. Lorem
                                                    Ipsum has been the
                                                    industry’s standard dummy
                                                    text ever since the 1500s,
                                                    when an unknown printer took
                                                    a galley of type and
                                                    scrambled it to make a type
                                                    specimen book. It has
                                                    survived not only five
                                                    centuries. Lorem Ipsum is
                                                    simply dummy text of the
                                                    printing and typesetting
                                                    industry. Lorem Ipsum has
                                                    been the industry’s standard
                                                    dummy text ever since the
                                                    1500s, when an unknown
                                                    printer took a galley of
                                                    type and scrambled it to
                                                    make a type specimen book.
                                                    It has survived not only
                                                    five centurie.
                                                </p>
                                                <img
                                                    src="/maincss/images/tablet_imac.png"
                                                    alt=" "
                                                    class="w-auto mt_34"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- tab end -->

                                    <!-- tab start -->
                                    <div
                                        id="pane-C"
                                        class="card tab-pane fade"
                                        role="tabpanel"
                                        aria-labelledby="tab-C"
                                    >
                                        <div
                                            id="collapse-C"
                                            class="collapse"
                                            data-parent="#content"
                                            role="tabpanel"
                                        >
                                            <div class="card-body">
                                                <h4
                                                    class="font_size_20 a_seamless_head"
                                                >
                                                    Manageable
                                                </h4>
                                                <p
                                                    class="font_size_18 mt_12 a_seamless_p mb_4"
                                                >
                                                    Lorem Ipsum is simply dummy
                                                    text of the printing and
                                                    typesetting industry. Lorem
                                                    Ipsum has been the
                                                    industry’s standard dummy
                                                    text ever since the 1500s,
                                                    when an unknown printer took
                                                    a galley of type and
                                                    scrambled it to make a type
                                                    specimen book. It has
                                                    survived not only five
                                                    centuries. Lorem Ipsum is
                                                    simply dummy text of the
                                                    printing and typesetting
                                                    industry. Lorem Ipsum has
                                                    been the industry’s standard
                                                    dummy text ever since the
                                                    1500s, when an unknown
                                                    printer took a galley of
                                                    type and scrambled it to
                                                    make a type specimen book.
                                                    It has survived not only
                                                    five centurie.
                                                </p>
                                                <img
                                                    src="/maincss/images/tablet_imac.png"
                                                    alt=" "
                                                    class="w-auto mt_34"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- tab end -->
                                    <!-- tab start -->
                                    <div
                                        id="pane-D"
                                        class="card tab-pane fade"
                                        role="tabpanel"
                                        aria-labelledby="tab-D"
                                    >
                                        <div
                                            id="collapse-D"
                                            class="collapse"
                                            data-parent="#content"
                                            role="tabpanel"
                                        >
                                            <div class="card-body">
                                                <h4
                                                    class="font_size_20 a_seamless_head"
                                                >
                                                    Customizable
                                                </h4>
                                                <p
                                                    class="font_size_18 mt_12 a_seamless_p mb_4"
                                                >
                                                    Lorem Ipsum is simply dummy
                                                    text of the printing and
                                                    typesetting industry. Lorem
                                                    Ipsum has been the
                                                    industry’s standard dummy
                                                    text ever since the 1500s,
                                                    when an unknown printer took
                                                    a galley of type and
                                                    scrambled it to make a type
                                                    specimen book. It has
                                                    survived not only five
                                                    centuries. Lorem Ipsum is
                                                    simply dummy text of the
                                                    printing and typesetting
                                                    industry. Lorem Ipsum has
                                                    been the industry’s standard
                                                    dummy text ever since the
                                                    1500s, when an unknown
                                                    printer took a galley of
                                                    type and scrambled it to
                                                    make a type specimen book.
                                                    It has survived not only
                                                    five centurie.
                                                </p>
                                                <img
                                                    src="/maincss/images/tablet_imac.png"
                                                    alt=" "
                                                    class="w-auto mt_34"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- tab end -->
                                    <!-- tab start -->
                                    <div
                                        id="pane-E"
                                        class="card tab-pane fade"
                                        role="tabpanel"
                                        aria-labelledby="tab-E"
                                    >
                                        <div
                                            id="collapse-E"
                                            class="collapse"
                                            data-parent="#content"
                                            role="tabpanel"
                                        >
                                            <div class="card-body">
                                                <h4
                                                    class="font_size_20 a_seamless_head"
                                                >
                                                    Accessible
                                                </h4>
                                                <p
                                                    class="font_size_18 mt_12 a_seamless_p mb_4"
                                                >
                                                    Lorem Ipsum is simply dummy
                                                    text of the printing and
                                                    typesetting industry. Lorem
                                                    Ipsum has been the
                                                    industry’s standard dummy
                                                    text ever since the 1500s,
                                                    when an unknown printer took
                                                    a galley of type and
                                                    scrambled it to make a type
                                                    specimen book. It has
                                                    survived not only five
                                                    centuries. Lorem Ipsum is
                                                    simply dummy text of the
                                                    printing and typesetting
                                                    industry. Lorem Ipsum has
                                                    been the industry’s standard
                                                    dummy text ever since the
                                                    1500s, when an unknown
                                                    printer took a galley of
                                                    type and scrambled it to
                                                    make a type specimen book.
                                                    It has survived not only
                                                    five centurie.
                                                </p>
                                                <img
                                                    src="/maincss/images/tablet_imac.png"
                                                    alt=" "
                                                    class="w-auto mt_34"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- tab end -->
                                    <!-- tab start -->
                                    <div
                                        id="pane-F"
                                        class="card tab-pane fade"
                                        role="tabpanel"
                                        aria-labelledby="tab-F"
                                    >
                                        <div
                                            id="collapse-F"
                                            class="collapse"
                                            data-parent="#content"
                                            role="tabpanel"
                                        >
                                            <div class="card-body">
                                                <h4
                                                    class="font_size_20 a_seamless_head"
                                                >
                                                    Real-Time
                                                </h4>
                                                <p
                                                    class="font_size_18 mt_12 a_seamless_p mb_4"
                                                >
                                                    Lorem Ipsum is simply dummy
                                                    text of the printing and
                                                    typesetting industry. Lorem
                                                    Ipsum has been the
                                                    industry’s standard dummy
                                                    text ever since the 1500s,
                                                    when an unknown printer took
                                                    a galley of type and
                                                    scrambled it to make a type
                                                    specimen book. It has
                                                    survived not only five
                                                    centuries. Lorem Ipsum is
                                                    simply dummy text of the
                                                    printing and typesetting
                                                    industry. Lorem Ipsum has
                                                    been the industry’s standard
                                                    dummy text ever since the
                                                    1500s, when an unknown
                                                    printer took a galley of
                                                    type and scrambled it to
                                                    make a type specimen book.
                                                    It has survived not only
                                                    five centurie.
                                                </p>
                                                <img
                                                    src="/maincss/images/tablet_imac.png"
                                                    alt=" "
                                                    class="w-auto mt_34"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- tab end -->
                                    <!-- tab start -->
                                    <div
                                        id="pane-G"
                                        class="card tab-pane fade"
                                        role="tabpanel"
                                        aria-labelledby="tab-G"
                                    >
                                        <div
                                            id="collapse-G"
                                            class="collapse"
                                            data-parent="#content"
                                            role="tabpanel"
                                        >
                                            <div class="card-body">
                                                <h4
                                                    class="font_size_20 a_seamless_head"
                                                >
                                                    Insightful
                                                </h4>
                                                <p
                                                    class="font_size_18 mt_12 a_seamless_p mb_4"
                                                >
                                                    Lorem Ipsum is simply dummy
                                                    text of the printing and
                                                    typesetting industry. Lorem
                                                    Ipsum has been the
                                                    industry’s standard dummy
                                                    text ever since the 1500s,
                                                    when an unknown printer took
                                                    a galley of type and
                                                    scrambled it to make a type
                                                    specimen book. It has
                                                    survived not only five
                                                    centuries. Lorem Ipsum is
                                                    simply dummy text of the
                                                    printing and typesetting
                                                    industry. Lorem Ipsum has
                                                    been the industry’s standard
                                                    dummy text ever since the
                                                    1500s, when an unknown
                                                    printer took a galley of
                                                    type and scrambled it to
                                                    make a type specimen book.
                                                    It has survived not only
                                                    five centurie.
                                                </p>
                                                <img
                                                    src="/maincss/images/tablet_imac.png"
                                                    alt=" "
                                                    class="w-auto mt_34"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <!-- tab end -->

                                    <!-- Tab content div end -->
                                </div>

                                <!-- Left panel End -->
                            </div>
                        </div>

                        <div class="d-block text-center">
                            <a
                                href="/create-company-store"
                                class="btn btn_orange bg_primary_orange text_white py_22 px_44 m-auto"
                                >Create Company Store</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "CompanyStore",
    components: {},
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
        document.body.classList.add("footer_spacing_mange");
        /* eslint-disable */
        $(".shop_by_brand_logo").owlCarousel({
            loop: false,
            margin: 0,
            nav: true,
            dots: false,
            responsive: {
                1: {
                    items: 1
                },
                600: {
                    items: 2
                },
                1000: {
                    items: 3
                },
                1200: {
                    items: 6
                }
            }
        });
        /* eslint-enable */
    }
};
</script>
